import Cookies from 'js-cookie';
import { getApiCallAction, postApiCallAction } from 'Redux/utilities';

import {
	deleteKey,
	resetStore,
	setDataToSubmit,
	setDiscountDataToSubmit,
	setDiscountFieldInfo,
	setErrorMessagesVisible,
	setFieldInfo,
	setStep,
	setWindowSize
} from './actions';
import types from './types';

const fetchExtensions = sessionId => getApiCallAction(`/api/extensions/${sessionId}`, types.GET_CALLS.FETCH_EXTENSIONS);

const fetchProducts = sessionId => getApiCallAction(`/api/products/${sessionId}`, types.GET_CALLS.FETCH_PRODUCTS);

const fetchEnableStep2Form = () => getApiCallAction('/api/enableStep2Form', types.GET_CALLS.FETCH_ENABLE_STEP_2_FORM);

const fetchForms = () => getApiCallAction('/api/forms', types.GET_CALLS.FETCH_FORMS);

const fetchFormFields = () => getApiCallAction('/api/formFields', types.GET_CALLS.FETCH_FORM_FIELDS);

const fetchConstants = () => getApiCallAction('/api/constants', types.GET_CALLS.FETCH_CONSTANTS);

const submit = data => postApiCallAction('/api/createContract', types.POST_CALLS.SUBMIT, data);

const activateStep2 = data => postApiCallAction('/api/activateStep2', types.POST_CALLS.ACTIVATE_STEP_2, data);

const saveSession = data => postApiCallAction('/api/session/save', types.POST_CALLS.SAVE_SESSION, data);

const logData = data => postApiCallAction('/api/log', types.POST_CALLS.LOG_DATA, data);

const login = data =>
	postApiCallAction('/api/user/login', types.POST_CALLS.LOGIN, data, response => {
		Cookies.set('userSessionId', response.success.sessionId, { expires: 365, path: '' });
	});

const checkUserSession = sessionId => getApiCallAction(`/api/user/check/${sessionId}`, types.GET_CALLS.CHECK_USER_SESSION);

const fetchSession = sessionId => getApiCallAction(`/api/session/get/${sessionId}`, types.GET_CALLS.FETCH_SESSION);

const setActiveStep =
	(activeStep, anchor = 'viato-contract-generator', smooth = false) =>
	dispatch => {
		document.body.classList.remove('loading-done');
		document.body.classList.add('loading-start');
		document.body.setAttribute('data-contract-generator-step', activeStep);

		setTimeout(() => {
			dispatch(setStep(activeStep));

			return Promise.resolve().then(() => {
				window.location.hash = activeStep;

				setTimeout(
					() => {
						document.body.classList.remove('loading-start');
						document.body.classList.add('loading-done');
					},
					smooth ? 0 : 50
				);

				setTimeout(
					() => {
						const yOffset = 150;
						const element = document.getElementById(anchor);
						const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;

						window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
					},
					smooth ? 143 : 0
				);
			});
		}, 143);
	};

export {
	fetchExtensions,
	fetchProducts,
	setActiveStep,
	resetStore,
	setDataToSubmit,
	setErrorMessagesVisible,
	setFieldInfo,
	submit,
	activateStep2,
	fetchEnableStep2Form,
	fetchFormFields,
	deleteKey,
	fetchForms,
	setWindowSize,
	fetchConstants,
	saveSession,
	fetchSession,
	login,
	logData,
	checkUserSession,
	setDiscountFieldInfo,
	setDiscountDataToSubmit
};
